import get from 'lodash/get';
import { getFeature } from '../../tools/features';

const isActive = (data, appKey, tooltipKey) => {
  if (
    getFeature('SDE_TRAINING_TOOL_TIPS') &&
    getFeature(`${appKey.toUpperCase()}_TRAINING_TOOL_TIPS`)
  ) {
    if (typeof data[tooltipKey] === 'boolean') {
      return data[tooltipKey];
    }
    return !!data.displayToolTip;
  }
  return null;
};

export const parseOnboarding = (data) => {
  const intros = {
    tour: !data.skipTheTour,
    tooltips: !data.viewedIntroduction,
    trackit: !data.viewedTrackitNotification,
    referrals: !data.viewedReferralNotification,
    documentLibrary: !data.viewedDocLibNotification,
    DLTeamsView: !data.viewedDLTeamsViewNotification,
    dashboard: !data.viewedDashboardNotification,
    digisec: !data.viewedDSNotification,
  };

  const tooltips = {
    claims: isActive(data, 'claims', 'displayClaimsTooltip'),
    eligibility: isActive(data, 'eligibility', 'displayEligibilityTooltip'),
    trackit: isActive(data, 'trackit', 'displayTrackitTooltip'),
    referrals: isActive(data, 'referrals', 'displayReferralTooltip'),
    documentLibrary: isActive(data, 'docvault', 'displatyDocLibTooltip'),
    DLTeamsView: isActive(data, 'dl_teams_view', 'displayDLTeamsViewTooltip'),
    dashboard: isActive(data, 'dashboard', 'displayDashboardTooltip'),
    digisec: isActive(data, 'digisec', 'displayDSTooltip'),
  };

  const dbValues = {
    claims: get(data, 'displayClaimsTooltip'),
    eligibility: get(data, 'displayEligibilityTooltip'),
    trackit: get(data, 'displayTrackitTooltip'),
    referrals: get(data, 'displayReferralTooltip'),
    documentLibrary: get(data, 'displatyDocLibTooltip'),
    DLTeamsView: get(data, 'displayDLTeamsViewTooltip'),
    dashboard: get(data, 'displayDashboardTooltip'),
    digisec: get(data, 'displayDSTooltip'),
  };

  Object.keys(tooltips).forEach((key) => {
    if (typeof tooltips[key] !== 'boolean') {
      delete tooltips[key];
    }
  });

  return {
    intros,
    tooltips,
    dbValues,
  };
};
